<rotec-modal-v2
  [title]="'TOOLING_Tooling: VALUE' | translate: { value: state.tooling.name || '' }"
  [hideModalTitle]="true"
  [disablePaddingMainPart]="true"
  [darkMode]="true"
  width="80vw"
  height="95vh"
>
  <ng-container ngProjectAs="modal-main">
    <div class="sections">
      <section class="section left">
        <img
          alt="Tooling Image"
          [class.emptyImg]="!state.tooling.pictureId"
          [src]="state.tooling.pictureId | rotecImageV2 | async"
        />
      </section>
      <section class="section right">
        <div class="content general">
          <h2 class="content-title">{{ state.tooling.name }}</h2>
          <div class="row">
            <p class="row-name" translate>COMMON_Inventory Number</p>
            <div class="row-value">
              {{ state.tooling.inventoryNo || '-' }}
            </div>
          </div>
          <div class="row">
            <p class="row-name" translate>COMMON_Manufacturer</p>
            <div class="row-value">{{ state.tooling.manufacturer || '-' }}</div>
          </div>
          <div class="row">
            <p class="row-name" translate>TOOLING_Type Designation</p>
            <div class="row-value">{{ state.tooling.typeDesignation || '-' }}</div>
          </div>
          <div class="row">
            <p class="row-name" translate>
              {{ 'Used for VALUE Machines' | translate: { value: state.machines.length } }}
            </p>
            <div class="row-value">
              @for (machine of state.machines; track machine) {
                <rotec-chip-v2 [darkGray]="true" [whiteFont]="true" class="chip">{{
                  machine.name
                }}</rotec-chip-v2>
              }
            </div>
          </div>
        </div>
        <div class="main">
          <div class="content">
            <h4 class="content-title" translate>Details</h4>
            <div class="row">
              <p class="row-name" translate>COMMON_Serial Number</p>
              <div class="row-value">{{ state.tooling.serial || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>COMMON_Manufacturer ID</p>
              <div class="row-value">{{ state.tooling.manufacturerId || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>TOOLING_Tool Type</p>
              <div class="row-value">{{ state.tooling.toolType || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>TOOLING_Schenck Material Number</p>
              <div class="row-value">{{ state.tooling.schenckMatNo || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>TOOLING_Verification Level</p>
              <div class="row-value">
                {{ (state.tooling.verificationLevel | rotecToolingVerificationLevel) || '-' }}
              </div>
            </div>
            <div class="row">
              <p class="row-name" translate>COMMON_Main Contact</p>
              <div class="row-value">{{ state.tooling.mainContact || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>COMMON_Storage Location</p>
              <div class="row-value">{{ state.tooling.storageLocation || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>COMMON_Workplace</p>
              <div class="row-value">{{ state.tooling.workplace || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>TOOLING_For Rotor(s)</p>
              <div class="row-value">{{ state.tooling.toolingForRotor || '-' }}</div>
            </div>
          </div>

          <ma-task-list
            [tasks]="state.tasks"
            (openTask)="openTask($event)"
            (deleteTask)="deleteTask($event)"
          ></ma-task-list>
        </div>
      </section>
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-primary-v2 dark (click)="modalRef.close()">
      {{ 'Close' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
